"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBillingSummaryLegacyToBillingSummaryCX = void 0;
var core_1 = require("../../../core");
var mapBillingSummaryLegacyToBillingSummaryCX = function (data) {
    var _a;
    if (!((_a = data.billingSummary) === null || _a === void 0 ? void 0 : _a.billablePeriods)) {
        return [];
    }
    var retailer = core_1.configService.getConfig().retailer;
    var history = data.billingSummary.billablePeriods.map(function (period) { return ({
        startDate: period.start,
        endDate: period.end,
        totalCharges: {
            gross: {
                value: period.totalCharge.grossCharge.pounds,
                currency: retailer.currencyCode,
            },
        },
        isStatementAvailable: period.isStatementAvailable,
    }); });
    return history;
};
exports.mapBillingSummaryLegacyToBillingSummaryCX = mapBillingSummaryLegacyToBillingSummaryCX;
